<template>
  <el-input ref='input'
            type="textarea"
            v-model='val'
            :style='cssStyle'
            :rows="rows"
            @focus='$refs.input.select()'
            @change="$emit('change', $event)">
  </el-input>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    cssStyle: {
      default: "width: 100%"
    },
    rows: {
      default: 3
    },
    value: String,
  },
  data() {
    return {
      val: this.value || ''
    }
  },
  watch: {
    value: function(value) {
      this.val = value;
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cx/cxTextArea.vue